import { render, staticRenderFns } from "./UsagesReviewForm.vue?vue&type=template&id=a43d0b52&"
import script from "./UsagesReviewForm.vue?vue&type=script&lang=js&"
export * from "./UsagesReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports